module.exports = __webpack_public_path__ + "static/img/4.776dff2.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/products/5/8/2/sp/4.png
// module id = cZxb
// module chunks = 0